import type { JSX } from 'react'
import * as era from '!/era'
import { ui } from '!/skin'
import { model as catchupsModel } from '$/catchups'
import { useUnit } from 'effector-react'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as catchupsPageModel from './model'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='catchup_other' />
}

const skin = era.skin('routes/catchups/root')

CatchupsPage.displayName = 'CatchupsPage'
export function CatchupsPage(): JSX.Element {
  const catchups = useUnit(catchupsModel.$allCatchupsToDisplayFormatted)

  const isCatchupsContentLoading = useUnit(
    catchupsPageModel.$catchupsContentLoading
  )
  const isProgramsContentLoading = useUnit(
    catchupsPageModel.$programsContentLoading
  )

  const fullHeight = catchups.length ? 'full-page-height' : ''

  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={`flex-column ${fullHeight}`}>
        <Skeleton pageType='catchups' isLoading={isCatchupsContentLoading}>
          <ui.RenderSkin name='catchupsRow' />
        </Skeleton>
        <Skeleton
          pageType='catchupsGridWithPrograms'
          isLoading={isProgramsContentLoading}
        >
          <ui.RenderSkin name='catchupsProgramsWithDateList' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
